export default __webpack_public_path__ + "static/media/innotrafiklogo_original_en.e68743ed.png";